<template>
  <div>
    <Breadcrumbs
      main="User"
      :title="status == 0 ? 'Create User' : 'Update User'"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <px-card :actions="false">
            <div class="p-4">
              <div class="row">
                <div class="col-6">
                  <form class="theme-form" @submit.prevent="handleRegister">
                    <h4>{{ status == 0 ? "Create User" : "Update User" }}</h4>
                    <p>Masukan Data Personal Candidate</p>
                    <div class="form-group">
                      <label for="username">Username</label>
                      <input
                        type="text"
                        v-model="form.username"
                        name="username"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && !form.username }"
                      />
                      <div
                        v-show="submitted && !form.username"
                        class="invalid-feedback"
                      >
                        Username is required
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="username">Fullname</label>
                      <input
                        type="text"
                        v-model="form.fullname"
                        name="fullname"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && !form.fullname }"
                      />
                      <div
                        v-show="submitted && !form.fullname"
                        class="invalid-feedback"
                      >
                        Fullname is required
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="username">Email</label>
                      <input
                        type="email"
                        v-model="form.email"
                        name="email"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && !form.email }"
                      />
                      <div
                        v-show="submitted && !form.email"
                        class="invalid-feedback"
                      >
                        Email is required
                      </div>
                    </div>
                    <div class="form-group">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        v-model="form.password"
                        name="password"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && !form.password,
                        }"
                      />
                      <div
                        v-show="submitted && !form.password"
                        class="invalid-feedback"
                      >
                        Password is required
                      </div>
                    </div>
                    <div class="form-group">
                      <label htmlFor="password">Referensi</label>
                      <b-form-select
                        v-model="form.referensi"
                        :options="numberOptions"
                        :class="{
                          'is-invalid': submitted,
                        }"
                      ></b-form-select>
                      <div
                        v-show="submitted && !form.referensi"
                        class="invalid-feedback"
                      >
                        Referensi is required
                      </div>
                    </div>
                    <div class="form-group mt-3 mb-0">
                      <button
                        class="btn btn-primary btn-block"
                        :disabled="loggingIn"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </px-card>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import { dataUser } from '../../_services';
export default {
  data() {
    return {
      logo: localStorage.getItem("logo"),
      form: {
        id: "",
        username: "",
        password: "",
        email: "",
        fullname: "",
      },
      numberOptions: [{ value: "Other", text: "Other" }],
      submitted: false,
      status: 0, // 0 create | 1 Update
    };
  },
  computed: {
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
  },
  created() {
    if (this.$route.query.id) {
      this.status = 1;
      this.form.id = this.$route.query.id;
      this.fetchDataUser(this.$route.query.id);
    }
  },
  methods: {
    handleRegister() {
      this.submitted = true;
      if (
        this.form.username &&
        this.form.email &&
        this.form.fullname
      ) {
          if(this.status == 0){
              this.$store
                .dispatch("authentication/registrasi", this.form)
                .then((res) => {
                    if (res) {
                    this.$notify({
                        group: "toast",
                        type: "warning",
                        text: "Registrasi Berhasil, Silahkan Login dengan Account yang sudah di daftarkan",
                        time: 5000,
                    });
                    this.$router.push({
                        path: "/user/list",
                    });
                    } else {
                    this.$notify({
                        group: "toast",
                        type: "warning",
                        text: "Username atau Email Sudah digunakan",
                    });
                    }
                });
          }else{
              this.$store
                .dispatch("authentication/update", this.form)
                .then((res) => {
                    if (res) {
                    this.$notify({
                        group: "toast",
                        type: "warning",
                        text: "Update Berhasil, Silahkan Login dengan Account yang sudah di daftarkan",
                        time: 5000,
                    });
                    this.$router.push({
                        path: "/user/list",
                    });
                    } else {
                    this.$notify({
                        group: "toast",
                        type: "warning",
                        text: "Username atau Email Sudah digunakan",
                    });
                    }
                });
          }
        
      }
    },
    async fetchDataUser(id_user) {
      let data = await dataUser(id_user);

      this.form = {
        id: data.id,
        username: data.username,
        password: '',
        email: data.email,
        fullname: data.fullname,
        referensi: data.referensi
      };
    },
  },
};
</script>
